import { Component, OnInit, ViewChild, ElementRef, ɵSafeResourceUrl, Renderer2 } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfigService } from '../../../shared/appconfig/appconfig.service'
import { environment } from '../../../../environments/environment';
import { ChatExtensionService } from '@cloudradial/crchat-chatwidget';
import { Observable, of, delay } from 'rxjs';

@Component({
    selector: 'app-bot-bottest',
    templateUrl: './bot.component.html',
  styleUrls: ['./bot.component.scss']
})
export class BotTestComponent implements OnInit {
  public channel: string;
  public dev: boolean;
  public qa: boolean;
  public chatboxenv: string;
  public widgetApiUrl = AppConfigService.settings?.get('widgetApiUrl') || '';
  public safeUrl: SafeResourceUrl;
  public options: string;
  public isEmbedded: boolean = false;
  public widgetMode: string = 'widget';
  public chatExtension: ChatExtensionService;

  protected headers: HttpHeaders;
  @ViewChild('chatboxParent', { static: false }) chatboxParent: ElementRef;

  constructor(
    private http: HttpClient,
    private renderer: Renderer2,
    private actRoute: ActivatedRoute,
    private sanitizer: DomSanitizer) {

    this.dev = (environment.chatboxenv === 'dev');
    this.qa = (environment.chatboxenv === 'qa');
    this.chatboxenv = environment.chatboxenv;
    this.channel = this.actRoute.snapshot.params.id;
    
    // Check if embedded mode is requested
    let embeddedParam = this.actRoute.snapshot.queryParamMap.get('embedded');
    this.isEmbedded = embeddedParam === 'true' || embeddedParam === '1';
    this.widgetMode = this.isEmbedded ? 'embedded' : 'widget';
    
    // Check if extension is requested
    let extensionParam = this.actRoute.snapshot.queryParamMap.get('extension');
    let useExtension = extensionParam === 'true' || extensionParam === '1';

    console.log('bottest - route params:', this.actRoute.snapshot.params);
    console.log('bottest - query params:', this.actRoute.snapshot.queryParamMap);
    console.log('bottest - channel:', this.channel);
    console.log('bottest - embedded:', this.isEmbedded);
    console.log('bottest - paramMap:', this.actRoute.snapshot.paramMap.get('id'));
    console.log('bottest - environment:', environment);
    console.log('bottest - dev flag:', this.dev);
    console.log('bottest - qa flag:', this.qa);

    let env = "";
    if (environment.chatboxenv) {
      env = ", \"env\": \"" + environment.chatboxenv + "\" ";
    }
    
    // Set isPopup to false when in embedded mode
    let isPopup = this.isEmbedded ? "false" : "true";
    this.options = "{ \"isOpen\": \"true\", \"isPopup\": \"" + isPopup + "\", \"loadHistory\": \"true\", \"autoStart\": \"true\" " + env + " }";

    // Create the test chat extension only if requested
    if (useExtension) {
      this.chatExtension = {
        // beforeMessageSend - modifies the message before it's sent
        beforeMessageSend: (message) => {
          console.log('BotTest Extension: Intercepting message before send:', message);
          
          // Example modifications (commented out to avoid modifying messages):
          // 1. Add a prefix to the message text
          // message.text = '[BotTest Modified] ' + message.text;
          
          // 2. Add custom data
          // if (!message.data) {
          //   message.data = JSON.stringify({
          //     timestamp: new Date().toISOString(),
          //     userAgent: navigator.userAgent,
          //     customField: 'BotTest Extension was here!',
          //     page: 'bottest',
          //     environment: this.chatboxenv
          //   });
          // }
          
          // 3. Add a custom payload to trigger extension search for testing
          // Set the payload to trigger extension search on every message for demo purposes
          //message.payload = 'extension.search';
          
          // IMPORTANT: Must return the message (unmodified now)
          return message;
        },

      // onMessageSent callback
      onMessageSent: (message) => {
        console.log('BotTest Extension: Message was sent:', message);
      },

      // onMessageReceived callback
      onMessageReceived: (message) => {
        console.log('BotTest Extension: Message received:', message);
      },

      // Example search implementation (returns an Observable)
      search: (query) => {
        console.log('BotTest Extension: Searching for:', query);
        
        // Add 3-second delay for all searches to demonstrate loading feature
        console.log('BotTest Extension: Simulating 3-second search delay...');
        return of([
          `BotTest Result 1 for "${query}" (after 3s delay)`, 
          `BotTest Result 2 for "${query}" (after 3s delay)`, 
          `BotTest Result 3 for "${query}" (after 3s delay)`
        ]).pipe(delay(3000));
      },

      // Example navigate implementation
      navigate: (url) => {
        console.log('BotTest Extension: Custom navigation to:', url);
        // Could use custom routing logic here instead of window.open
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    };
    } else {
      this.chatExtension = undefined;
    }
  }

  ngOnInit() {

  }

  ngAfterViewInit() {

    //this.chatbox.init(this.renderer, this.chatboxParent, this.channel);

    //const s = this.renderer.createElement('script');
    //s.type = 'text/javascript';
    //s.src = 'https://cdn.chatstyle.ai/chatbox/chatstyleai.js';
    //s.text = '';
    //if (s.readyState) {
    //  s.onreadystatechange = () => {
    //    if (s.readyState === "loaded" || s.readyState === "complete") {
    //      s.onreadystatechange = null;
    //      console.log('chatbox ready 1');
    //      this.loadChatbox();
    //    }
    //  };
    //} else {
    //  s.onload = () => {
    //    console.log('chatbox ready 2');
    //    this.loadChatbox();
    //  };
    //}

    //this.renderer.appendChild(this.chatboxParent.nativeElement, s);


  }

  //loadChatbox() {
  //  const chatbox = this.renderer.createElement('chatstyleai-chatbox');
  //  this.renderer.setAttribute(chatbox, 'id', 'chatbox');
  //  this.renderer.setAttribute(chatbox, 'channel', this.channel);
  //  this.renderer.setAttribute(chatbox, 'version', '');
  //  this.renderer.setAttribute(chatbox, 'options', '{ "isOpen": "false", "loadHistory": "true", "autoStart":"true", "createNew": "true" }');

  //  // TODO - Consider version in debugging?

  //  this.renderer.appendChild(this.chatboxParent.nativeElement, chatbox);

  //}


}
